export default "__VITE_ASSET__CIMf_vrJ__"